import React, { VFC } from 'react';

import { Box, Icon } from '@rbilabs/components-library';
import styled from 'styled-components';

import { designTokens } from 'styles/constants/design-tokens';
import { primitive } from 'styles/constants/primitives';

import { ITimsRewardsDisclaimer } from './types';

const StyledMessageText = styled.span`
  color: ${designTokens['text-default']};
`;

export const TimsRewardsDisclaimer: VFC<ITimsRewardsDisclaimer> = ({ message }) => {
  return (
    <Box
      align="center"
      justify="center"
      width="100vw"
      background={designTokens['background-inline-alert']}
      padding={`${primitive.$spacing1} ${primitive.$spacing5}`}
      margin={`${primitive.$spacing2} 0 0 0`}
    >
      <Icon
        height={primitive.$spacing4}
        width={primitive.$spacing4}
        aria-hidden
        color="icon-default"
        icon="info"
      />
      <Box minWidth="0.5rem" width="0.5rem" maxWidth="0.5rem" />
      <StyledMessageText>{message}</StyledMessageText>
    </Box>
  );
};

export default TimsRewardsDisclaimer;
